<template>
    <LayoutAuth :logoClickable="true" @logoClick="goToLogin">
        <FormRecuperar />
    </LayoutAuth>
</template>

<script>
import LayoutAuth from '@/components/layouts/LayoutAuth.vue';
import FormRecuperar from '@/components/forms/FormRecuperar.vue';

export default {
    name: 'RecuperarContrasena',
    components: {
        LayoutAuth,
        FormRecuperar,
    },
    methods: {
        goToLogin() {
            this.$router.push('/login').catch(() => { });
        },
    },
};
</script>

<style>
.background-fixed {
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.repeating-gradient {
    background-image: radial-gradient(circle,
            rgba(227, 227, 227, 1) 0%,
            rgba(126, 126, 126, 1) 89%,
            rgba(91, 92, 91, 1) 100%);
}

.img-difuminada {
    mask-image: linear-gradient(to bottom, transparent 0%, white 30%, white 70%, transparent 100%);
    -webkit-mask-image: linear-gradient(to bottom, transparent 0%, white 30%, white 70%, transparent 100%);
}
</style>
